import React, { Fragment, Component } from 'react'

import getLabels from '../../utils/getLabels'

import FlightMetaData from '../../containers/FlightMetaData'
import NewBookingForm from '../../containers/NewBookingForm'
import AdditionalNotesForm from '../../containers/AdditionalNotesForm'
import CustomTourOperator from '../../containers/TourOperator/CustomTourOperator'
import NewBookingCSVUpload from '../../containers/NewBookingCSVUpload'

import Modal from '../Modal'
import PageHeader from '../PageHeader'
import BackButton from '../BackButton'
import Spinner from '../Spinner'
import NoAllotmentCount from '../NoAllotmentCount'
import InteractivePopUp from '../InteractivePopUp'
import CSVUpload from '../CSVUpload'

import styles from './NewBooking.module.scss'
import globalStyles from '../../styles/global.module.scss'

interface NewBookingPropsInterface {
  requestSSRs: Function
  requestFlight: Function
  closeCSVUpload: Function

  departureFlightId: string
  returnFlightId: string
  smartClassAllotmentCount: number
  economyClassAllotmentCount: number

  isTOFlight: boolean
  isSpecialSSRModalOpen: boolean
  noAllotmentCount: boolean
  isCSVUploadModalOpen: boolean
  hasCustomTopSelection: boolean
  flightsAreLoaded: boolean
}

interface NewBookingStateInterface {
  isFormSubmittable: boolean
  isCSVUploadable: boolean
}

export default class NewBooking extends Component<
  NewBookingPropsInterface,
  NewBookingStateInterface
> {
  state = {
    isFormSubmittable: false,
    isCSVUploadable: true,
  }

  setIsFormSubmittable = (isFormSubmittable: boolean) => {
    this.setState({ isFormSubmittable })
  }

  setIsCSVUploadable = (isCSVUploadable: boolean) => {
    this.setState({ isCSVUploadable })
  }

  componentDidMount() {
    const {
      requestSSRs,
      requestFlight,
      departureFlightId,
      returnFlightId,
    } = this.props

    requestSSRs(departureFlightId)
    requestFlight(departureFlightId)

    if (returnFlightId) {
      requestFlight(returnFlightId)
    }
  }

  private readonly _renderForm = () => {
    const {
      isTOFlight,
      departureFlightId,
      returnFlightId,
      noAllotmentCount,
      smartClassAllotmentCount,
      economyClassAllotmentCount,
    } = this.props

    if (noAllotmentCount) return <NoAllotmentCount />

    return (
      <div
        className={`${globalStyles['page-item']} ${styles['form-container']}`}
      >
        <div className={styles['form-container-inner']}>
          <h2 className={styles['title']}>{getLabels('new_booking_title')}</h2>
          <div className={styles['csv-upload-trigger']}>
            <NewBookingCSVUpload isDisabled={!this.state.isCSVUploadable} />
          </div>

          <div className={styles['form-wrapper']}>
            <NewBookingForm
              isTOFlight={isTOFlight}
              departureFlightId={departureFlightId}
              returnFlightId={returnFlightId}
              smartClassAllotmentCount={smartClassAllotmentCount}
              economyAllotmentCount={economyClassAllotmentCount}
              setIsFormSubmittable={this.setIsFormSubmittable}
              setIsCSVUploadable={this.setIsCSVUploadable}
              isFormSubmittable={this.state.isFormSubmittable}
            />
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {
      departureFlightId,
      returnFlightId,
      flightsAreLoaded,
      isSpecialSSRModalOpen,
      isCSVUploadModalOpen,
      closeCSVUpload,
    } = this.props

    const mainContent = flightsAreLoaded ? this._renderForm() : <Spinner />

    return (
      <Fragment>
        <PageHeader>
          <div className={styles['controls']}>
            <BackButton />

            <CustomTourOperator />
          </div>

          <div className={styles['meta-data-container']}>
            <div className={styles['meta-data']}>
              <FlightMetaData
                flightId={departureFlightId}
                showPassengers={false}
              />
            </div>

            {returnFlightId && (
              <div className={styles['meta-data']}>
                <FlightMetaData
                  flightId={returnFlightId}
                  showPassengers={false}
                />
              </div>
            )}
          </div>
        </PageHeader>

        <div className={styles['main-content-wrapper']}>{mainContent}</div>

        {isSpecialSSRModalOpen && (
          <Modal isOpen={true}>
            <AdditionalNotesForm />
          </Modal>
        )}

        <InteractivePopUp
          isPopUpOpen={isCSVUploadModalOpen}
          closePopUp={closeCSVUpload}
        >
          <CSVUpload pristine={true} />
        </InteractivePopUp>
      </Fragment>
    )
  }
}
